import { showNotification } from '@helpers/notification-helper';
import { PlusOutlined } from '@icon';
import { deleteExpertise, getMyExpertise } from '@services/external/user.api';
import { Button } from '@ui';
import React from 'react';
import { useQuery } from 'react-query';
import SpecializationForm from './components/specialization-form';
import { TableSC } from './specialization-profile.styled';
import { useColumns } from './specialization-profile.utils';

const SpecializationProfile: React.FunctionComponent = () => {
  const [addVisible, setAddVisible] = React.useState(false);

  const { data, isFetching, refetch } = useQuery(['my-expertise'], async () => {
    const { data } = await getMyExpertise();

    return data.data;
  });

  const tableExtra = React.useMemo(
    () => (
      <Button Icon={PlusOutlined} size="medium" onClick={() => setAddVisible(true)}>
        Pridať špecializáciu
      </Button>
    ),
    [],
  );

  const onClose = React.useCallback(() => {
    setAddVisible(false);
  }, []);

  const afterSubmit = React.useCallback(() => {
    setAddVisible(false);
    refetch();
  }, []);

  const onDelete = React.useCallback(async (record: any) => {
    try {
      await deleteExpertise(record.code);
      refetch();
      showNotification({ type: 'SUCCESS', title: 'Špecializácia odstránená', copy: '' });
    } catch (error) {
      console.log(error);
      showNotification({ type: 'ERROR', title: 'Niečo sa pokazilo', copy: '' });
    }
  }, []);

  const columns = useColumns({ onDeleteClick: onDelete });
  const tableData = data ?? [];
  return (
    <>
      <TableSC.Header title={`Špecializácie (${tableData.length})`} extra={tableExtra} />
      <TableSC
        loading={isFetching}
        columns={columns}
        data={tableData}
        showEmpty
        emptyTitle="Žiadne špecializácie"
      />
      <SpecializationForm visible={addVisible} onClose={onClose} afterSubmit={afterSubmit} />
    </>
  );
};

export default SpecializationProfile;
